export default "__VITE_ASSET__DooaNoJt__"